export const columnFields = ['id', 'materialCategoryId', 'name', 'createdAt'] as const;
